var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7487 10.4591C10.5655 10.6556 10.3447 10.8133 10.0993 10.9226C9.85389 11.032 9.58899 11.0908 9.32039 11.0955C9.05179 11.1002 8.78498 11.0508 8.53589 10.9502C8.2868 10.8496 8.06053 10.6998 7.87057 10.5098C7.68061 10.3199 7.53085 10.0936 7.43024 9.84447C7.32963 9.59536 7.28022 9.32853 7.28496 9.05991C7.2897 8.79128 7.34849 8.52637 7.45782 8.28096C7.56716 8.03555 7.7248 7.81468 7.92135 7.63153M13.2959 13.0065C12.156 13.8754 10.7681 14.3568 9.335 14.3803C4.66727 14.3803 2 9.0453 2 9.0453C2.82945 7.49942 3.97987 6.14881 5.3741 5.08408C7.17298 3.71032 8.8636 3.70922 9.335 3.71032C14.0027 3.71032 16.67 9.0453 16.67 9.0453C16.2652 9.8026 15.3363 11.4511 13.2959 13.0065Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.38a976e843c41b905c675068dbdad019.svg";
export { ForwardRef as ReactComponent };